import React from "react"

import PropTypes from "prop-types"

import * as styles from "./newsletter-section-title.module.scss"

const NewsletterSectionTitle = ({ section }) => (
  <div className={styles.wrapper}>
    <div
      className={`${styles.title} ${styles[`title__${section.color?.replaceAll("-", "")}`]}`}
    >
      {section.title}
    </div>
  </div>
)

export default NewsletterSectionTitle

NewsletterSectionTitle.propTypes = {
  section: PropTypes.object.isRequired,
}
